import { render } from "./template.vue?vue&type=template&id=049b2318&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"

import "./template.vue?vue&type=style&index=0&id=049b2318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049b2318"]])

export default __exports__